<template>
    <label>
        <input type="file" @change="change" :multiple="multiple">
        <div class="label">
            <span v-text="label"></span>
            <ul v-if="files.length">
                <li v-for="file in files" :key="file.name" v-text="file.name">
                </li>
            </ul>
        </div>
    </label>
</template>

<script>
export default {
    name: 'FileInput',
    props: {
        label: { default: 'Ficheiros' },
        multiple: { default: true },
    },
    data() {
        return {
            files: [],
        }
    },
    computed: {
        labelText() {
            if (this.files == null) {
                return this.label
            }
            return this.label
        },
    },
    methods: {
        change(e) {
            this.files = e.target.files
            this.$emit('change', e)
        },
    },
}
</script>

<style scoped lang="scss">
label {

    input[type=file] {
        display: none;

        &+.label {
            padding: 1rem;
            border: 2px dashed;
            border-radius: 10px;
            width: 100%;
        }
    }
}
</style>
